import { WorkflowWorkflowType } from '@calm/evexia-web-sdk';
import createWorkflowApi from '@rhg/libs/api/create-workflow-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, useMutation } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';
import { workflowNextStepQueryOptions } from '../use-workflow-next-step';
import {
    workflowByDefnIdForRecipientQueryOptions,
    workflowByTypeForRecipientQueryOptions,
} from '../use-workflows';

interface StartWorkflowParameters {
    workflowDefnId: string;
    workflowType?: WorkflowWorkflowType;
}
export function useStartWorkflow() {
    const { getAccessTokenSilently } = useAuth();
    const { activeCircle } = useActiveCircle();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({ workflowDefnId }: StartWorkflowParameters) => {
            const api = createWorkflowApi(getAccessTokenSilently);
            const response = await api.v1StartWorkflow({
                circleAuthorizationToken: activeCircle!.authorizationJWT!,
                recipientId: activeCircle!.recipient.id,
                workflowDefnId,
            });
            return response;
        },
        onSuccess: (_, { workflowDefnId, workflowType }) => {
            invalidateQueryKey(
                workflowByDefnIdForRecipientQueryOptions.queryKey({
                    workflowDefnId,
                    recipientId: activeCircle!.recipient.id,
                })
            );
            invalidateQueryKey(
                workflowByTypeForRecipientQueryOptions.queryKey({
                    recipientId: activeCircle!.recipient.id,
                    workflowType,
                })
            );
            invalidateQueryKey(
                workflowNextStepQueryOptions.queryKey({
                    recipientId: activeCircle!.recipient.id,
                    workflowDefnId,
                })
            );
        },
    });
    return {
        startWorkflow: mutate,
        startWorkflowAsync: mutateAsync,
        ...otherProps,
    };
}
